import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { SxHttpService } from './sxHttp.service';
import { DataLogic } from '../model/interfaces/dataLogic.interface';

@Injectable()
export class DataLogicService {
    private serviceUrl = 'api/DataLogic';

    constructor(
        private http: Http, 
        private sxHttp: SxHttpService
    ) { }

    getAll(): Observable<DataLogic[]> {
        return this.sxHttp
        .get(this.serviceUrl + "/GetAll")
        .map(response => response.json().data as DataLogic[]);
    }
  
    getById(DataLogicId: string): Observable<DataLogic> {
        return this.sxHttp
        .get(this.serviceUrl + "/GetById" + "/" + DataLogicId)
        .map(response => response.json().data as DataLogic);
    }

    getList(): Observable<DataLogic>{
        return this.sxHttp
        .get(this.serviceUrl + "/GetLists")
        .map((response) => {
            return response.json().data as DataLogic;
        });
    }

    create(model: DataLogic): Promise<any>{
        return this.sxHttp.post(this.serviceUrl + '/Create', model)
        .toPromise()
        .then(response => {
            return response.json().data
        });
    }

    update(model: DataLogic): Promise<any>{
        return this.sxHttp.post(this.serviceUrl + '/Update', model)
        .toPromise()
        .then(response => {
            return response.json().data
        });
    }

    delete(dataLogicId: string): Promise<Boolean> {
        return this.sxHttp
          .delete(this.serviceUrl + "/Delete" + "/" + dataLogicId)
          .toPromise()
          .then((result) => result.json().data);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/dataLogic.service.ts